import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { ReviewsEmptySnippet } from 'shared/components/ReviewsSnippet';
import { reviewsElementId } from 'shared/constants/reviews';
import { useDailyRentReviews } from 'shared/hooks/useReviewsMiniWidget';
import { selectEmptyReviews } from 'shared/selectors/dailyrentData/selectEmptyReviews';

export function ReviewsEmptySnippetContainer() {
  const { isReviewsEnabled } = useDailyRentReviews();
  const emptyReviews = useSelector(selectEmptyReviews);

  if (!isReviewsEnabled || !emptyReviews) {
    return null;
  }

  const { title, description, writeReviewButtonUrl } = emptyReviews;

  return (
    <CardSectionNew>
      <ReviewsEmptySnippet
        elementId={reviewsElementId}
        title={title}
        description={description}
        writeReviewButtonUrl={writeReviewButtonUrl}
      />
    </CardSectionNew>
  );
}
